import React, { useEffect, useState } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth, db } from '../../firebase';
import { doc, getDoc } from 'firebase/firestore';
import { Navigate } from 'react-router-dom';
import Loader from '../Loader'; // 👈 Import Loader

export default function RequireAdmin({ children }) {
    const [user, loading] = useAuthState(auth);
    const [isAdmin, setIsAdmin] = useState(null); // null = loading
    const [checkingRole, setCheckingRole] = useState(true);

    useEffect(() => {
        if (loading) return;
        if (!user) {
            setCheckingRole(false);
            return;
        }

        const checkRole = async () => {
            try {
                const userDoc = await getDoc(doc(db, "users", user.uid));
                if (userDoc.exists() && userDoc.data().role === 'admin') {
                    setIsAdmin(true);
                } else {
                    setIsAdmin(false);
                }
            } catch (err) {
                console.error("Error checking admin role:", err);
                setIsAdmin(false);
            } finally {
                setCheckingRole(false);
            }
        };

        checkRole();
    }, [user, loading]);

    if (loading || checkingRole) {
        return <Loader text="Verifying Permissions..." />;
    }

    if (!user) {
        return <Navigate to="/admin/login" />;
    }

    if (!isAdmin) {
        return (
            <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', fontFamily: 'sans-serif' }}>
                <h1 style={{ color: '#e02424' }}>Access Denied</h1>
                <p>You do not have administrative privileges.</p>
                <button
                    onClick={() => auth.signOut()}
                    style={{ marginTop: '20px', padding: '10px 20px', cursor: 'pointer' }}
                >
                    Logout
                </button>
            </div>
        );
    }

    return children;
}
